export default `float fbm (vec3 seed) {
  float result = 0.;
  float a = .5;
  for (int i = 0; i < 5; ++i) {
    result += gyroid(seed/a+result/a)*a;
    a /= 2.;
  }
  return result;
}
float de(vec3 p){
  
  float details = sin(time*.2-fbm(p)+length(p));
  return max(abs(details*.05), p.z+2.);
}`